import React from 'react'

const WReturnRefund = () => {
  return (
     <main className="main">
      <section className="serv-comp">
        <div className="common-container">
          <div className="comn-heading">
            <h3>
              Return <span>Refund</span>{" "}
            </h3>
            <p>
              Nikah-e-Muslim offers digital subscription-based services designed
              to help users find a compatible life partner through a secure and
              halal matchmaking process. As our services are digital in nature,
              no physical returns are applicable.
            </p>

            <p>
              Subscription fees paid on Nikah-e-Muslim are generally
              non-refundable once the service has been activated. This includes
              access to premium features such as viewing contact details,
              sending messages, profile visibility enhancements, and other paid
              benefits.
            </p>

            <p>
              Refunds may be considered only in exceptional cases such as
              duplicate payments, technical errors, or unauthorized
              transactions. Any refund request must be submitted within a
              reasonable time period along with valid proof of payment.
            </p>

            <p>
              To request a refund, users must contact our support team through
              the official contact channels provided on the website or app.
              Each request will be reviewed carefully, and decisions will be
              made at the sole discretion of Nikah-e-Muslim.
            </p>

            <p>
              If a refund is approved, the amount will be credited back to the
              original payment method used during the transaction. Processing
              time may vary depending on the payment provider or bank.
            </p>

            <p>
              Nikah-e-Muslim reserves the right to suspend or terminate accounts
              found misusing the platform or violating our Terms & Conditions.
              In such cases, no refund will be applicable.
            </p>

            <p>
              By purchasing a subscription or using paid services on
              Nikah-e-Muslim, you acknowledge and agree to this Return and
              Refund Policy.
            </p>
          </div>
        </div>
      </section>
    </main>
  )
}

export default WReturnRefund
